import type { RouteObject } from 'react-router';

import { ContentAssetsPage } from './ContentAssets';

/**
 * `/content/:contentItemId/assets`. One `RouteObject`, so the file is
 * `.route.tsx` singular.
 *
 * One route serves both shapes: the **record's type** decides whether it draws a
 * film's single asset or a series' seasons, and an operator never converts one
 * into the other from here — the type is an authoring decision.
 */
export const contentAssetsRoute: RouteObject = {
  path: 'content/:contentItemId/assets',
  element: <ContentAssetsPage />,
};
